/**
 * @generated SignedSource<<ef6dadb1903e12c64547abe83a1d37b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleBeforeYouGoWidget$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleBeforeYouGoTopicsContent" | "beforeYouGoActionWidgetContent">;
  readonly " $fragmentType": "articleBeforeYouGoWidget";
};
export type articleBeforeYouGoWidget$key = {
  readonly " $data"?: articleBeforeYouGoWidget$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleBeforeYouGoWidget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleBeforeYouGoWidget",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleBeforeYouGoTopicsContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "beforeYouGoActionWidgetContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "e8172ed1d2343382c439fb9f784e976c";

export default node;
